import { Avatar, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import SubscriptionImageIco from "../../../assets/icons/SubscriptionImageIco";
import CommonButton from "../../../component/Button";
import { CustomDiv } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { platformBlackLogo } from "../../../utils/logo";

export default function SubscriptionExpired() {
  const URL = process.env.REACT_APP_WEBSITE_URL;
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const lg = useMediaQuery("(min-width:767px)");

  return (
    <CustomDiv padding="2rem">
      {typeof localStorageData?.org_logo_url === "string" ? (
        <CommonGrid2 display={"flex"} gap={"10px"} alignItems="center">
          <Avatar
            src={localStorageData?.org_logo_url}
            sx={{
              width: lg ? "40px" : "30px",
              height: lg ? "40px" : "30px",
            }}
          />

          <Typography variant={lg ? "h5" : "subtitle3"} fontWeight={700}>
            {localStorageData?.organization}
          </Typography>
        </CommonGrid2>
      ) : (
        <CustomDiv width="max-content">
          {platformBlackLogo({height: "50px"})}
        </CustomDiv>
      )}

      <CommonGrid2
        padding={"2rem"}
        background="#EBF1F4"
        borderRadius={"10px"}
        marginTop={"6rem"}
        display={"flex"}
        flexDirection={"column"}
        gap={"1rem"}
        position={"relative"}
      >
        <Typography
          variant="h1"
          color="#8396A8"
          fontWeight={700}
          sx={{
            background: "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 40%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          This module is currently only available on the custom plan{" "}
        </Typography>
        <Typography variant="h2" color="#A9B4BE" fontWeight={700}>
          Contact Titan Data to upgrade.{" "}
        </Typography>
        <CustomDiv
          position="absolute"
          style={{ top: "0px", right: "0px", height: "100%" }}
        >
          <SubscriptionImageIco />
        </CustomDiv>
        <CommonButton
          value={"Contact Us"}
          width={"max-content"}
          padding={"10px 2rem"}
          fontWeight={700}
          marginTop={"1rem"}
          onClick={() => {
            window.open(`${URL}/contact-us`, "_blank", "noopener,noreferrer");
          }}
        />
      </CommonGrid2>
    </CustomDiv>
  );
}
